module.exports = __webpack_public_path__ + "img/medalha-empreendedorismo-baixa-renda.1f438e30.jpeg";